// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TabsV2_wrapper__1v6if"};